import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { IconsModule } from "@va/core-library/icons";
import { LabsPageComponent } from "./labs-page/labs-page.component";

import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { LabsRouteGuardService } from "./labs-route-guard.service";
import { LabsPageNavComponent } from "./labs-page-nav/labs-page-nav.component";
import { LabsDashboardComponent } from "./labs-dashboard/labs-dashboard.component";
import { LabsReportsComponent } from "./labs-reports/labs-reports.component";
import { NoAccessLabsComponent } from "./no-access-labs/no-access-labs.component";
import { ModalEditAccessComponent } from "./modal-edit-access/modal-edit-access.component";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { SharedModule } from "../shared/shared.module";

const routes: Routes = [
  {
    path: "",
    component: LabsDashboardComponent,
    canActivate: [LabsRouteGuardService],
    data: {
      title: "Labs Page",
    },
  },
  {
    path: "drugdashboard",
    redirectTo: "/home",
  },
  {
    path: ":pageName",
    component: LabsPageComponent,
    data: {
      title: "Labs Page",
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LabsPageRoutingModule {}

@NgModule({
  declarations: [
    LabsPageComponent,
    LabsPageNavComponent,
    LabsDashboardComponent,
    LabsReportsComponent,
    NoAccessLabsComponent,
    ModalEditAccessComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IconsModule,

    NzDropDownModule,

    NzSwitchModule,
    NzDividerModule,
    LabsPageRoutingModule,
    NzGridModule,
    NzLayoutModule,
    NzSkeletonModule,
    SharedModule,
  ],
  exports: [LabsPageComponent, LabsPageNavComponent],
  entryComponents: [ModalEditAccessComponent],
})
export class LabsPageModule {}
